import HashWorker from '../workers/hash.worker.ts?worker';

export const BLOCK_SIZE = 4 * 1024 * 1024;

export interface HashResult { hashes: string[]; contentHash: string; size: number }

interface Pending {
  resolve: (r: HashResult) => void;
  reject: (e: Error) => void;
  onProgress?: ((ratio: number) => void) | undefined;
}

type WorkerMessage =
  | { id: string; type: 'progress'; done: number; total: number }
  | { id: string; type: 'done'; hashes: string[]; contentHash: string; size: number }
  | { id: string; type: 'error'; message: string };

const pending = new Map<string, Pending>();
let worker: Worker | null = null;
let counter = 0;

function ensureWorker(): Worker {
  if (worker) return worker;
  worker = new HashWorker();
  worker.onmessage = (event: MessageEvent<WorkerMessage>) => {
    const msg = event.data;
    const entry = pending.get(msg.id);
    if (!entry) return;

    if (msg.type === 'progress') { entry.onProgress?.(msg.done / msg.total); return; }
    pending.delete(msg.id);
    if (msg.type === 'done') {
      entry.resolve({ hashes: msg.hashes, contentHash: msg.contentHash, size: msg.size });
    } else {
      entry.reject(new Error(msg.message));
    }
  };
  worker.onerror = () => {
    for (const [, entry] of pending) entry.reject(new Error('해시 워커 오류'));
    pending.clear();
    worker?.terminate();
    worker = null;
  };
  return worker;
}

export function hashFile(
  file: File, onProgress?: (ratio: number) => void,
): Promise<HashResult> {
  const id = `h${++counter}`;
  return new Promise<HashResult>((resolve, reject) => {
    pending.set(id, { resolve, reject, onProgress });
    ensureWorker().postMessage({ id, file });
  });
}

/** 빈 파일의 콘텐츠 해시 = sha256('') — 서버 규칙과 동일하게 계산된다. */
export const EMPTY_CONTENT_HASH =
  'e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855';
